<template>
    <footer>
        <div class="container">
            <div class="row">
                <div class="col-6 offset-md-3 footer-center">
                    <a href="https://www.kopiraittila.fi" target="_blank">
                        <img class="logo" :src="'../../../static/'+currentLocale+'/logo.png'" alt="Kopiraittilan Koulu">
                    </a>
                </div>
                <div class="col-6 text-center d-md-none footer-kopiosto">
                    <a href="https://www.kopiosto.fi" target="_blank"><img class="logo img-fluid" src="/static/logo-kopiosto-vaaka-valkoinen.png" alt=""></a>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <ul class="pl-4">
                        <li class="ml-3"><router-link :to="{path: '/' + currentLocale + '/tekijat'}">{{ $t('footer.tekijat', currentLocale) }}</router-link></li>
                        <li class="ml-3"><router-link :to="{path: '/' + currentLocale + '/kayttoehdot'}">{{ $t('footer.kayttoehdot', currentLocale) }}</router-link></li>
                        <li class="ml-3"><router-link :to="{path: '/' + currentLocale + '/evasteet'}">{{ $t('footer.evasteet', currentLocale) }}</router-link></li>
                        <li class="ml-3"><router-link :to="{path: '/' + currentLocale + '/yhteystiedot'}">{{ $t('footer.yhteystiedot', currentLocale) }}</router-link></li>
                    </ul>
                </div>
                <div class="col-md-4 link-forgotten footer-center">
                    <a href="#" v-on:click="showLogin">{{ $t('footer.unohditko', currentLocale) }}</a>
                </div>
                <div class="col-md-3 offset-md-1">
                    <p class="social-media-share">{{ $t('footer.jaa', currentLocale) }}</p>
                    <div class="social-media">
                        <a href="./">
                            <img src="../../../static/icons/icon-facebook.png" alt="">
                        </a>

                        <a href="./">
                            <img src="../../../static/icons/icon-instagram.png" alt="">
                        </a>

                        <a href="./">
                            <img src="../../../static/icons/icon-twitter.png" alt="">
                        </a>
                    </div>
                </div>
            </div>
            <div class="row pl-3 pl-md-5 mt-3 mt-md-auto">
              <div class="pl-0 col-md-4 d-flex align-items-center">
                <c-info v="2" ct="0" pb="Kopiosto ry" ca="2" ma="2" na="Kirsi Salmela ja Johanna Haapiainen-Makkonen" cb="2" mb="1" nb="Simon Bussman ja Tarja Petrell" cc="1" mc="3" nc="" tr="5" cr="" vr="2" sr="0" tl="https://korkeakoulu.kopiraittila.fi/fi/kayttoehdot" tc="" vc="" sc="" sl="" dl="fi" es="0" ep="1" cp="1" cl="eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJlbWFpbCI6Im5ldXZvbnRhQGtvcGlvc3RvLmZpIn0" ></c-info>
              </div>
                <div class="col-md-4 text-center d-none d-md-block">
                    <a href="https://www.kopiosto.fi" target="_blank"><img class="logo img-fluid" src="../../../static/logo-kopiosto-vaaka-valkoinen.png" alt=""></a>
                </div>
            </div>
          <div class="row">
            <div class="col-md-12 d-flex justify-content-center text-center">

            </div>
          </div>

            <div class="row">
                <div class="col-md-12 copyright small">
                    <p>{{ $t('footer.copyright', currentLocale) }}</p>
                </div>
            </div>
        </div>


    </footer>
</template>
<script>
  export default {
    computed: {
        currentLocale() {
            return this.$route.params.locale
        },
    },
    mounted () {
      let cInfoScript = document.createElement('script')
      cInfoScript.setAttribute('src', 'https://www.c-info.fi/c-info.js')
      document.head.appendChild(cInfoScript)
    },
    methods: {
      showLogin: function (event) {
        event.preventDefault()
        this.$emit('showLogin')
      }
    },
    computed: {
        currentLocale() {
            return this.$route.params.locale
        },
    },
  }
</script>

<style lang="scss">
    footer {
        padding: 1rem 0;
        p {
            color: white;
        }
        a {
            color: white;
            &:hover {
                color: white;
            }
        }

        background: #303030;
        color: white;
        .social-media-share {
            font-size: 18px;
            margin-bottom: 0.5rem;
        }
        .logo {
            max-width: 320px;
            margin-bottom: 1rem;
            margin-top: 1rem;
            width: 100%;
        }
        .social-media {
            a {
                img {
                    width: 40px;
                    margin: 0 0.25rem;
                }
            }
        }
        ul {
            list-style: none;
            margin: 0;
            li {
                margin: 0 0 0 2rem;
                font-size: 18px;
                a {
                    color: white;
                }
            }
        }
        .footer-center {
            text-align: center;
            @media(max-width: 767.98px) {
                text-align: left;
            }
        }
        .footer-kopiosto {
            display:flex;
            align-items: center;
        }
        .copyright {
            text-align:center;
            margin-top:2rem;
            padding-bottom:5rem;
        }
    }

    @media(max-width: 767.98px) {
        footer {
            .footer-center {
                text-align: left;
            }
            ul {
                padding-left: 0;
                li {
                    margin: 0;
                }
            }
            .link-forgotten {
                margin: 2rem 0;
            }
            .copyright {
                text-align:left;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/components/Footer.vue